/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/components/ShareModal.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/styles';
import { FontIcon } from 'react-md';
import PrimaryButton from 'common/components/buttons/primaryButton';
import AlertDialogSlide from 'common/components/dialog/dialog';
import LoadingProgress from 'common/components/progress/loading';
import Table from 'common/components/table/tableGeneral';
import { NewActivity } from 'common/components/email';
import PushSimulator from 'common/components/pushSimulator';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import { isMobile } from 'react-device-detect';
import { BASE_S3, BASE_API, USER_TOKEN } from 'config/consts';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';

const AntTabs = withStyles({
  root: {},
  indicator: {
    backgroundColor: '#1890ff',
  },
})(Tabs);

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`share-tabpanel-${index}`}
      aria-labelledby={`share-tab-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.any,
  index: PropTypes.any,
  value: PropTypes.any,
};

const ShareModal = ({ open, onClose, activity, auth }) => {
  const [tabValue, setTabValue] = useState(0);

  // E-mail de teste
  const [sendToMyEmail, setSendToMyEmail] = useState(false);
  const [testEmail, setTestEmail] = useState('');
  const [customDescription, setCustomDescription] = useState(false);
  const [customSubject, setCustomSubject] = useState(false);
  const [alternativeDescription, setAlternativeDescription] = useState('');
  const [alternativeSubject, setAlternativeSubject] = useState('');
  const [sendingTest, setSendingTest] = useState(false);

  // Envio para participantes
  const [customParticipantDescription, setCustomParticipantDescription] = useState(false);
  const [customParticipantSubject, setCustomParticipantSubject] = useState(false);
  const [participantDescription, setParticipantDescription] = useState('');
  const [participantSubject, setParticipantSubject] = useState('');
  const [sendingParticipants, setSendingParticipants] = useState(false);
  const [confirmEmailOpen, setConfirmEmailOpen] = useState(false);

  // Push
  const [pushTitle, setPushTitle] = useState('');
  const [pushText, setPushText] = useState('');
  const [schedulePush, setSchedulePush] = useState(false);
  const [scheduledTime, setScheduledTime] = useState('');
  const [sendingPush, setSendingPush] = useState(false);
  const [confirmPushOpen, setConfirmPushOpen] = useState(false);

  // Dados carregados
  const [segmentedUsers, setSegmentedUsers] = useState([]);
  const [segmentedLoading, setSegmentedLoading] = useState(false);
  const [shareHistory, setShareHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  // Colunas da tabela de participantes
  const columns = [
    { field: 'name', title: 'Nome' },
    { field: 'email', title: 'E-mail' },
  ];

  // Colunas da tabela de histórico
  const historyColumns = [
    { field: 'type.name', title: 'Tipo' },
    {
      title: 'Usuário',
      render: (rowData) =>
        rowData.user_received
          ? rowData.user_received.name
            ? rowData.user_received.name
            : 'N/A'
          : 'N/A',
    },
    {
      title: 'E-mail',
      render: (rowData) => (rowData.single_email ? rowData.single_email : 'N/A'),
    },
    {
      title: 'E-mail Aberto',
      render: (rowData) => (rowData.opened ? 'Sim' : 'Não'),
    },
    { field: 'createdAt', title: 'Data', type: 'date' },
  ];

  // Dados do usuário e station
  const userEmail = auth?.user?.email || '';
  const station = auth?.user?.establishments?.[0]?.stations?.[0] || {};
  const establishment = auth?.user?.establishments?.[0] || {};

  // Dados da ação
  const actionData = activity?.rawData || activity || {};

  // Buscar usuários segmentados e histórico ao abrir
  React.useEffect(() => {
    if (activity && open) {
      fetchSegmentedUsers();
      fetchShareHistory();
    }
  }, [activity, open]);

  const fetchSegmentedUsers = async () => {
    const actionId = activity?.rawData?.id || activity?.id;
    const stationId = activity?.rawData?.station_id || station?.id || '';
    if (!actionId) return;
    setSegmentedLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      const response = await axios.get(
        `${BASE_API}/get-segmented-users/${actionId}/${stationId}`,
        { headers: { Authorization: `${token}` } }
      );
      setSegmentedUsers(response.data?.usersToSend || response.data || []);
    } catch (error) {
      console.error('Erro ao buscar usuários segmentados:', error);
      setSegmentedUsers([]);
    } finally {
      setSegmentedLoading(false);
    }
  };

  const fetchShareHistory = async () => {
    const actionId = activity?.rawData?.id || activity?.id;
    if (!actionId) return;
    setHistoryLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      const response = await axios.get(
        `${BASE_API}/history-share-action/${actionId}`,
        { headers: { Authorization: `${token}` } }
      );
      setShareHistory(response.data || []);
    } catch (error) {
      console.error('Erro ao buscar histórico de divulgação:', error);
      setShareHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleSendTest = async () => {
    const emailToSend = sendToMyEmail ? userEmail : testEmail;
    if (!emailToSend) {
      toastr.warning('Atenção', 'Informe um e-mail para envio de teste');
      return;
    }
    const actionId = activity?.rawData?.id || activity?.id;
    if (!actionId) return;
    setSendingTest(true);
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      await axios.post(
        `${BASE_API}/send-mail-to-test/${actionId}`,
        {
          action_id: actionId,
          email: emailToSend,
          station_id: station?.id,
          user_id: auth?.user?.id,
          sendToUserMail: sendToMyEmail,
          alternative_summary: customDescription ? alternativeDescription : undefined,
          alternative_subject: customSubject ? alternativeSubject : undefined,
          image: actionData.image,
        },
        { headers: { Authorization: `${token}` } }
      );
      toastr.success('Sucesso', 'E-mail de teste enviado com sucesso!');
    } catch (error) {
      toastr.error('Erro', error?.response?.data?.message || 'Erro ao enviar e-mail de teste');
    } finally {
      setSendingTest(false);
    }
  };

  const handleSendToParticipants = async () => {
    const actionId = activity?.rawData?.id || activity?.id;
    if (!actionId) return;
    setSendingParticipants(true);
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      await axios.post(
        `${BASE_API}/send-mail-to-participants/${actionId}`,
        {
          image: actionData.image,
          alternative_summary: customParticipantDescription ? participantDescription : undefined,
          alternative_subject: customParticipantSubject ? participantSubject : undefined,
        },
        { headers: { Authorization: `${token}` } }
      );
      toastr.success('Sucesso', 'E-mails enviados para os participantes!');
      fetchShareHistory();
    } catch (error) {
      toastr.error('Erro', error?.response?.data?.message || 'Erro ao enviar e-mails');
    } finally {
      setSendingParticipants(false);
      setConfirmEmailOpen(false);
    }
  };

  const handleSendPush = async () => {
    const actionId = activity?.rawData?.id || activity?.id;
    if (!actionId) return;
    if (!pushTitle && !pushText) {
      toastr.warning('Atenção', 'Informe o título e/ou texto da notificação push');
      return;
    }
    setSendingPush(true);
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      await axios.post(
        `${BASE_API}/send-push-to-participants/${actionId}`,
        {
          title: pushTitle,
          body: pushText,
          scheduledTime: schedulePush ? scheduledTime : undefined,
        },
        { headers: { Authorization: `${token}` } }
      );
      if (schedulePush) {
        toastr.success('Sucesso', 'Agendamento realizado com sucesso!');
      } else {
        toastr.success('Sucesso', 'Notificação push enviada com sucesso!');
      }
    } catch (error) {
      toastr.error('Erro', error?.response?.data?.message || 'Erro ao enviar push');
    } finally {
      setSendingPush(false);
      setConfirmPushOpen(false);
    }
  };

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };

  // Gerar alternativeSummary para preview do email
  const alternativeSummaryForPreview = customDescription ? alternativeDescription : undefined;

  // Renderizar tela vazia (resultados)
  const renderEmptyScreen = () => (
    <section id="statement-buy-points" style={{ height: '100vh' }}>
      <GeneralGrid container spacing={3} alignItems="center">
        <GeneralGrid item xs={12} md={6}>
          <GeneralGrid container spacing={3}>
            <GeneralGrid item xs={12}>
              <h2 className="signup-text">Essa atividade ainda não foi divulgada</h2>
            </GeneralGrid>
          </GeneralGrid>
        </GeneralGrid>
        <GeneralGrid item xs={12} md={6}>
          <img alt="" src={placeholder_illustration} className="img-fluid" />
        </GeneralGrid>
      </GeneralGrid>
    </section>
  );

  return (
    <AlertDialogSlide
      visible={open}
      onClose={onClose}
      title="Divulgação"
      maxWidth={isMobile ? 'xl' : 'lg'}
      height="95vh"
    >
      <AppBar
        style={{
          background: '#fff',
          boxShadow: 'none',
          border: 'none',
          marginBottom: 20,
        }}
        position="static">
        <AntTabs value={tabValue} onChange={handleTabChange}>
          <Tab style={{ color: '#000000' }} label="E-mail de teste" />
          <Tab style={{ color: '#000000' }} label="Envio para participantes" />
          <Tab style={{ color: '#000000' }} label="Resultados" />
          <Tab style={{ color: '#000000' }} label="Notificação Push" />
        </AntTabs>
      </AppBar>

      {/* ========== ABA 0: E-MAIL DE TESTE ========== */}
      <TabPanel value={tabValue} index={0}>
        <MaterialGrid container spacing={8}>
          <MaterialGrid item xs={6} style={{ borderRight: '1px solid lightgray' }}>
            <Typography style={{ textAlign: 'left', fontSize: 12, color: 'gray' }}>
              Pré-visualização
            </Typography>
            {station?.jsonData ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: NewActivity(actionData, station, establishment, alternativeSummaryForPreview),
                }}
              />
            ) : (
              <Box style={{ textAlign: 'center', padding: 20, color: '#999' }}>
                <Typography>Pré-visualização indisponível</Typography>
              </Box>
            )}
          </MaterialGrid>
          <MaterialGrid item xs={6}>
            <MaterialGrid item xs={12}>
              {/* Switch enviar para meu email */}
              <MaterialGrid item xs={12}>
                <Box display="flex" alignItems="center">
                  <Switch
                    checked={sendToMyEmail}
                    onChange={(e) => setSendToMyEmail(e.target.checked)}
                    color="primary"
                  />
                  <Typography variant="body1">
                    Enviar para {userEmail}
                  </Typography>
                </Box>
              </MaterialGrid>

              {/* Campo email */}
              <MaterialGrid item xs={12}>
                <TextField
                  label="E-mail para teste"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={sendToMyEmail ? userEmail : testEmail}
                  onChange={(e) => setTestEmail(e.target.value)}
                  disabled={sendToMyEmail}
                />
              </MaterialGrid>

              {/* Switch descrição */}
              <MaterialGrid
                item
                xs={12}
                style={{ marginTop: 16 }}>
                <Box
                  style={{ backgroundColor: '#f7f7f7', padding: 16, borderRadius: 4 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                      Deseja adicionar sua própria descrição da atividade?
                    </Typography>
                    <Switch
                      checked={customDescription}
                      onChange={(e) => setCustomDescription(e.target.checked)}
                      color="primary"
                    />
                  </Box>
                  <Typography variant="body2" style={{ color: '#999', fontSize: 12 }}>
                    {customDescription ? 'Ativado' : 'Selecione para escrever sua própria descrição para a atividade'}
                  </Typography>
                </Box>
              </MaterialGrid>
              {customDescription && (
                <MaterialGrid item xs={12} style={{ marginTop: 8 }}>
                  <TextField
                    label="Descrição alternativa"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={3}
                    value={alternativeDescription}
                    onChange={(e) => setAlternativeDescription(e.target.value)}
                  />
                </MaterialGrid>
              )}

              {/* Switch assunto */}
              <MaterialGrid
                item
                xs={12}
                style={{ marginTop: 16 }}>
                <Box
                  style={{ backgroundColor: '#f7f7f7', padding: 16, borderRadius: 4 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                      Deseja adicionar seu próprio assunto do e-mail?
                    </Typography>
                    <Switch
                      checked={customSubject}
                      onChange={(e) => setCustomSubject(e.target.checked)}
                      color="primary"
                    />
                  </Box>
                  <Typography variant="body2" style={{ color: '#999', fontSize: 12 }}>
                    {customSubject ? 'Ativado' : "Selecione para escrever seu próprio assunto do e-mail. O padrão é: 'Olá, temos uma nova atividade para você'"}
                  </Typography>
                </Box>
              </MaterialGrid>
              {customSubject && (
                <MaterialGrid item xs={12} style={{ marginTop: 8 }}>
                  <TextField
                    label="Assunto alternativo"
                    variant="outlined"
                    fullWidth
                    value={alternativeSubject}
                    onChange={(e) => setAlternativeSubject(e.target.value)}
                  />
                </MaterialGrid>
              )}

              {/* Botão */}
              <MaterialGrid container justifyContent="flex-end">
                <PrimaryButton
                  type="button"
                  color="primary"
                  disabled={sendingTest}
                  onClick={handleSendTest}>
                  {sendingTest ? 'Enviando...' : 'Enviar Teste'}
                </PrimaryButton>
              </MaterialGrid>
            </MaterialGrid>
          </MaterialGrid>
        </MaterialGrid>
      </TabPanel>

      {/* ========== ABA 1: ENVIO PARA PARTICIPANTES ========== */}
      <TabPanel value={tabValue} index={1}>
        {segmentedLoading ? (
          <Box display="flex" height="100vh" justifyContent="center" mt={7}>
            <LoadingProgress />
          </Box>
        ) : (
          <MaterialGrid container spacing={8}>
            <MaterialGrid item xs={6} style={{ borderRight: '1px solid lightgray' }}>
              <Typography style={{ textAlign: 'left', fontSize: 12, color: 'gray' }}>
                Pré-visualização
              </Typography>
              {station?.jsonData ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: NewActivity(actionData, station, establishment, customParticipantDescription ? participantDescription : undefined),
                  }}
                />
              ) : (
                <Box style={{ textAlign: 'center', padding: 20, color: '#999' }}>
                  <Typography>Pré-visualização indisponível</Typography>
                </Box>
              )}
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              <MaterialGrid item xs={12}>
                {/* Contagem de e-mails */}
                <MaterialGrid item xs={12}>
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography component="p">
                      {segmentedUsers.length}
                      {segmentedUsers.length > 1 || segmentedUsers.length < 1
                        ? ' e-mails serão enviados'
                        : ' e-mail será enviado'}{' '}
                    </Typography>
                    <Tooltip
                      style={{ marginLeft: 10 }}
                      title="Os emails serão enviados para todos os participantes que autorizaram o recebimento do e-mail (não solicitaram descadastramento), não ultrapassaram o limite de participações da atividade e estão dentro do segmento da atividade."
                      placement="top-start">
                      <FontIcon>help</FontIcon>
                    </Tooltip>
                  </Box>
                </MaterialGrid>

                {/* Tabela de participantes */}
                <MaterialGrid item xs={12} style={{ marginTop: 10 }}>
                  <Table title="Extrato" columns={columns} data={segmentedUsers} />
                </MaterialGrid>

                {/* Switch descrição */}
                <MaterialGrid
                  item
                  xs={12}
                  style={{ marginTop: 16 }}>
                  <Box
                    style={{ backgroundColor: '#f7f7f7', padding: 16, borderRadius: 4 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        Deseja adicionar sua própria descrição da atividade?
                      </Typography>
                      <Switch
                        checked={customParticipantDescription}
                        onChange={(e) => setCustomParticipantDescription(e.target.checked)}
                        color="primary"
                      />
                    </Box>
                    <Typography variant="body2" style={{ color: '#999', fontSize: 12 }}>
                      {customParticipantDescription ? 'Ativado' : 'Selecione para escrever sua própria descrição para a atividade'}
                    </Typography>
                  </Box>
                </MaterialGrid>
                {customParticipantDescription && (
                  <MaterialGrid item xs={12} style={{ marginTop: 8 }}>
                    <TextField
                      label="Descrição alternativa"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={3}
                      value={participantDescription}
                      onChange={(e) => setParticipantDescription(e.target.value)}
                    />
                  </MaterialGrid>
                )}

                {/* Switch assunto */}
                <MaterialGrid
                  item
                  xs={12}
                  style={{ marginTop: 16 }}>
                  <Box
                    style={{ backgroundColor: '#f7f7f7', padding: 16, borderRadius: 4 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        Deseja adicionar seu próprio assunto do e-mail?
                      </Typography>
                      <Switch
                        checked={customParticipantSubject}
                        onChange={(e) => setCustomParticipantSubject(e.target.checked)}
                        color="primary"
                      />
                    </Box>
                    <Typography variant="body2" style={{ color: '#999', fontSize: 12 }}>
                      {customParticipantSubject ? 'Ativado' : "Selecione para escrever seu próprio assunto do e-mail. O padrão é: 'Olá, temos uma nova atividade para você'"}
                    </Typography>
                  </Box>
                </MaterialGrid>
                {customParticipantSubject && (
                  <MaterialGrid item xs={12} style={{ marginTop: 8 }}>
                    <TextField
                      label="Assunto alternativo"
                      variant="outlined"
                      fullWidth
                      value={participantSubject}
                      onChange={(e) => setParticipantSubject(e.target.value)}
                    />
                  </MaterialGrid>
                )}

                {/* Botão */}
                <MaterialGrid container justifyContent="flex-end">
                  <PrimaryButton
                    type="button"
                    color="primary"
                    disabled={sendingParticipants}
                    onClick={() => setConfirmEmailOpen(true)}>
                    {sendingParticipants ? 'Enviando...' : 'Enviar E-mails'}
                  </PrimaryButton>
                </MaterialGrid>
              </MaterialGrid>
            </MaterialGrid>

            {/* Dialog de confirmação */}
            <Dialog
              open={confirmEmailOpen}
              onClose={() => setConfirmEmailOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description">
              <DialogTitle id="alert-dialog-title">{'Enviar o e-mail?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Ao clicar em enviar, todos os usuários listados na tabela anterior serão notificados.
                  Deseja continuar?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setConfirmEmailOpen(false)} color="primary">
                  Cancelar
                </Button>
                <Button onClick={handleSendToParticipants} color="primary" autoFocus>
                  Enviar
                </Button>
              </DialogActions>
            </Dialog>
          </MaterialGrid>
        )}
      </TabPanel>

      {/* ========== ABA 2: RESULTADOS ========== */}
      <TabPanel value={tabValue} index={2}>
        {historyLoading ? (
          <Box display="flex" height="100vh" justifyContent="center" mt={7}>
            <LoadingProgress />
          </Box>
        ) : shareHistory.length < 1 ? (
          renderEmptyScreen()
        ) : (
          <section id="statement-buy-points">
            <GeneralGrid container spacing={3}>
              <GeneralGrid item xs={12}>
                <GeneralGrid container spacing={3} justify="space-between" alignContent="space-between">
                  <GeneralGrid item xs={3}>
                    <span
                      style={{
                        fontFamily: 'Roboto',
                        fontWeight: 500,
                        fontSize: 24,
                      }}>
                      Histórico de divulgações
                    </span>
                    <Typography variant="body1" style={{ marginTop: 20 }}>
                      {shareHistory.length}{' '}
                      {shareHistory.length > 1 ? 'Envios' : 'Envio'}
                    </Typography>
                  </GeneralGrid>
                </GeneralGrid>
                <GeneralGrid container spacing={3}>
                  <GeneralGrid item xs={12}>
                    <Table title="Extrato" columns={historyColumns} data={shareHistory} />
                  </GeneralGrid>
                </GeneralGrid>
              </GeneralGrid>
            </GeneralGrid>
          </section>
        )}
      </TabPanel>

      {/* ========== ABA 3: NOTIFICAÇÃO PUSH ========== */}
      <TabPanel value={tabValue} index={3}>
        {segmentedLoading ? (
          <Box display="flex" height="100vh" justifyContent="center" mt={7}>
            <LoadingProgress />
          </Box>
        ) : (
          <MaterialGrid container spacing={8}>
            <MaterialGrid item xs={6} style={{ borderRight: '1px solid lightgray' }}>
              <Typography style={{ textAlign: 'left', fontSize: 12, color: 'gray' }}>
                Pré-visualização
              </Typography>
              <MaterialGrid container spacing={8}>
                <MaterialGrid
                  item
                  xs={12}
                  style={{
                    borderRight: '1px solid lightgray',
                    display: 'flex',
                    justifyContent: 'center',
                  }}>
                  <PushSimulator
                    title={pushTitle || 'Título da Push'}
                    body={pushText || 'Texto da push: aqui você pode detalhar melhor a sua notificação'}
                  />
                </MaterialGrid>
              </MaterialGrid>
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              <MaterialGrid item xs={12}>
                {/* Contagem de pushes */}
                <MaterialGrid item xs={12}>
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography component="p">
                      {segmentedUsers.length}
                      {segmentedUsers.length > 1 || segmentedUsers.length < 1
                        ? ' pushes serão enviadas'
                        : ' push será enviada'}{' '}
                    </Typography>
                    <Tooltip
                      style={{ marginLeft: 10 }}
                      title="Essa quantidade é calculada de acordo com a segmentação escolhida por você na configuração da atividade. Além disso, não enviamos notificações para usuários que ultrapassaram o limite de participações."
                      placement="top-start">
                      <FontIcon>help</FontIcon>
                    </Tooltip>
                  </Box>
                </MaterialGrid>

                {/* Tabela de participantes */}
                <MaterialGrid item xs={12} style={{ marginTop: 10 }}>
                  <Table
                    title="Extrato"
                    columns={columns}
                    data={segmentedUsers}
                  />
                </MaterialGrid>

                {/* Campo Título */}
                <MaterialGrid item xs={12}>
                  <MaterialGrid item xs={12} style={{ marginBottom: 16, marginTop: 16 }}>
                    <TextField
                      label="Título"
                      variant="outlined"
                      fullWidth
                      value={pushTitle}
                      onChange={(e) => setPushTitle(e.target.value.slice(0, 60))}
                      inputProps={{ maxLength: 60 }}
                      helperText={`${pushTitle.length}/60`}
                    />
                  </MaterialGrid>

                  {/* Campo Texto */}
                  <MaterialGrid item xs={12}>
                    <TextField
                      label="Texto"
                      variant="outlined"
                      fullWidth
                      multiline
                      value={pushText}
                      onChange={(e) => setPushText(e.target.value)}
                    />
                  </MaterialGrid>

                  {/* Switch Agendar envio */}
                  <MaterialGrid item xs={12}>
                    <Box display="flex" alignItems="center">
                      <Switch
                        checked={schedulePush}
                        onChange={(e) => setSchedulePush(e.target.checked)}
                        color="primary"
                        name="schedule"
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                      />
                      <Typography variant="body1">Agendar envio</Typography>
                    </Box>
                  </MaterialGrid>
                </MaterialGrid>

                {schedulePush && (
                  <MaterialGrid item xs={12} style={{ marginTop: 16 }}>
                    <TextField
                      label="Agendar envio"
                      type="datetime-local"
                      variant="outlined"
                      fullWidth
                      value={scheduledTime}
                      onChange={(e) => setScheduledTime(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </MaterialGrid>
                )}

                {/* Botão */}
                <MaterialGrid container justifyContent="flex-end">
                  <PrimaryButton
                    type="button"
                    color="primary"
                    disabled={sendingPush || (!pushTitle && !pushText)}
                    onClick={() => setConfirmPushOpen(true)}>
                    {sendingPush ? 'Enviando...' : 'Enviar Push'}
                  </PrimaryButton>
                </MaterialGrid>
              </MaterialGrid>
            </MaterialGrid>

            {/* Dialog de confirmação push */}
            <Dialog
              open={confirmPushOpen}
              onClose={() => setConfirmPushOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description">
              <DialogTitle id="alert-dialog-title">{'Enviar a notificação push?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Ao clicar em enviar, todos os usuários listados na tabela anterior serão notificados.
                  Deseja continuar?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setConfirmPushOpen(false)} color="primary">
                  Cancelar
                </Button>
                <Button onClick={handleSendPush} color="primary" autoFocus>
                  Enviar
                </Button>
              </DialogActions>
            </Dialog>
          </MaterialGrid>
        )}
      </TabPanel>
    </AlertDialogSlide>
  );
};

ShareModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  activity: PropTypes.object,
  auth: PropTypes.object,
};

export default ShareModal;
